  // Time constraints
export const MIN_TIME = '09:00' as const;
export const MAX_TIME = '23:00' as const;
export const DEFAULT_TIME = '' as const;